const AUTH_ERROR_TRANSLATIONS: Record<string, string> = {
  "Invalid login credentials": "Nieprawidłowy email lub hasło",
  "Email not confirmed": "Email nie został potwierdzony",
  "User already registered": "Użytkownik już istnieje",
  "Invalid email": "Nieprawidłowy adres email",
  "Password should be at least 6 characters": "Hasło musi mieć co najmniej 6 znaków",
  "Password should be at least 6 characters.": "Hasło musi mieć co najmniej 6 znaków",
  "Unable to validate email address": "Nie można zweryfikować adresu email",
  "Unable to validate email address: invalid format": "Nieprawidłowy format adresu email",
  "Signups not allowed for this instance": "Rejestracja jest wyłączona",
  "Email rate limit exceeded": "Przekroczono limit wysyłania emaili",
  "Invalid password": "Nieprawidłowe hasło",
  "For security purposes, you can only request this once every 60 seconds":
    "Ze względów bezpieczeństwa możesz wysłać żądanie tylko raz na 60 sekund",
  "For security purposes, you can only request this after":
    "Ze względów bezpieczeństwa spróbuj ponownie za chwilę",
  "Email link is invalid or has expired": "Link weryfikacyjny jest nieprawidłowy lub wygasł",
  "New password should be different from the old password":
    "Nowe hasło musi być inne niż poprzednie",
  "Password is too weak": "Hasło jest zbyt słabe",
  "Anonymous sign-ins are disabled": "Logowanie anonimowe jest wyłączone",
  "Error sending recovery email": "Nie udało się wysłać emaila do resetowania hasła",
};

const NETWORK_ERROR_MESSAGE =
  "Brak połączenia z serwerem. Sprawdź internet i spróbuj ponownie.";

// Cross-browser fetch failure signatures: Safari/iOS ("Load failed"),
// Chrome/Edge ("Failed to fetch"), Firefox ("NetworkError when attempting to fetch resource").
const isNetworkError = (errorMessage: string): boolean => {
  const lower = errorMessage.toLowerCase();
  return (
    lower === "load failed" ||
    lower.includes("failed to fetch") ||
    lower.includes("networkerror") ||
    lower.includes("network request failed") ||
    lower.includes("err_internet_disconnected") ||
    lower.includes("err_network")
  );
};

export const translateAuthError = (errorMessage: string): string => {
  if (isNetworkError(errorMessage)) {
    return NETWORK_ERROR_MESSAGE;
  }

  if (AUTH_ERROR_TRANSLATIONS[errorMessage]) {
    return AUTH_ERROR_TRANSLATIONS[errorMessage];
  }

  const lowerMessage = errorMessage.toLowerCase();
  for (const [key, translation] of Object.entries(AUTH_ERROR_TRANSLATIONS)) {
    if (lowerMessage.includes(key.toLowerCase())) {
      return translation;
    }
  }

  return errorMessage;
};
